import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Flame, BookOpen, Palette, TrendingUp, ShieldCheck } from 'lucide-react';
const benefitsList = [{
  title: 'Técnica de caramelización',
  desc: "El secreto adaptado a olla común para lograr el 'Crocante Perfecto' que dura semanas.",
  icon: Flame,
  color: 'bg-palomitas-coral',
  bgColor: 'bg-palomitas-coral/10',
  borderColor: 'border-palomitas-coral/30'
}, {
  title: '+30 Recetas Estrella',
  desc: 'Oreo, Kinder, Nido, Lemon Pie, Frutos Rojos, Caramelo Salado.',
  icon: BookOpen,
  color: 'bg-palomitas-pink',
  bgColor: 'bg-palomitas-pink/10',
  borderColor: 'border-palomitas-pink/30'
}, {
  title: 'Presentación de Alto Impacto',
  desc: 'Para candy bar, souvenirs y eventos.',
  icon: Palette,
  color: 'bg-palomitas-purple',
  bgColor: 'bg-palomitas-purple/10',
  borderColor: 'border-palomitas-purple/30'
}, {
  title: 'Ventas Masivas',
  desc: 'Estrategias simples para vender a gran escala y conseguir clientes fijos.',
  icon: TrendingUp,
  color: 'bg-palomitas-emerald',
  bgColor: 'bg-palomitas-emerald/10',
  borderColor: 'border-palomitas-emerald/30'
}, {
  title: 'Rentabilidad Segura',
  desc: 'Qué productos vender primero para no perder dinero.',
  icon: ShieldCheck,
  color: 'bg-palomitas-orange',
  bgColor: 'bg-palomitas-orange/10',
  borderColor: 'border-palomitas-orange/30'
}];
export function Benefits() {
  return <section className="pt-20 pb-10 bg-palomitas-cream relative overflow-hidden" data-id="element-19">
      <div className="absolute -top-32 left-1/2 w-96 h-96 bg-palomitas-pink/5 rounded-full blur-3xl" data-id="element-20"></div>

      <div className="container px-4 mx-auto max-w-4xl relative z-10" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <span className="inline-block bg-palomitas-gold/20 text-palomitas-brown px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-4" data-id="element-23">
            💰 Beneficios
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-palomitas-brown mb-4" data-id="element-24">
            ¿Qué vas a lograr con este programa?
          </h2>
        </div>

        <div className="space-y-5" data-id="element-25">
          {benefitsList.map((benefit, index) => {
          const IconComponent = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`flex items-start gap-4 p-6 rounded-2xl ${benefit.bgColor} transition-colors border-2 ${benefit.borderColor}`} data-id="element-26">
                <div className={`${benefit.color} text-white p-3 rounded-xl flex-shrink-0`} data-id="element-27">
                  <IconComponent size={24} data-id="element-28" />
                </div>
                <div data-id="element-29">
                  <h3 className="text-xl font-bold text-palomitas-brown mb-1" data-id="element-30">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-700 text-lg" data-id="element-31">{benefit.desc}</p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}